export function isGrabbable(obj) {
    return 'grab' in obj;
}
